export default {
  'Enter a promo code! First limit people receive amount coins':
    'Podaj kod promocyjny! Ograniczona liczba pierwszych osób otrzyma monety',
};
